import globalNavHeight from 'nav-meta/global-nav-height';
import styled from 'styled-components';
const HEADER_HEIGHT = '175px';
export const MainContentWrapper = styled.div.withConfig({
  displayName: "MainContentWrapper",
  componentId: "sc-5hj7xq-0"
})(["height:calc( 100vh - ", " - ", " - ", " );width:100%;"], globalNavHeight, HEADER_HEIGHT, props => props.paddingBottom || '0px');